import { updateStore, addSessionToStore } from 'core_main/store';
import { maybeFetchCurrentTrackingToken } from 'core_main/api/tracking';
import { post, get, put, patch } from 'core_main/request';
import {
  validateSessionParams,
  validateCreateSessionParams,
  makeGetChatSessionsEndpoint,
  makeChatSessionEndpoint,
  makeChatSessionMessagesEndpoint,
  makeCreateChatSessionEndpoint,
  makeChatSessionReadEndpoint,
} from './helpers';
import { UpdateSessionOptions } from './types';

export const createSession = (parameters) => {
  const validationError = validateCreateSessionParams(parameters);

  if (validationError) {
    return Promise.reject(validationError);
  }

  return maybeFetchCurrentTrackingToken().then(() => {
    return post(makeCreateChatSessionEndpoint(parameters), {
      body: JSON.stringify({
        title: parameters.title,
        assistant: parameters.assistant,
        brand: parameters.brand,
        custom: parameters.custom,
      }),
    }).then((response) => {
      const customerId = response.data.relationships.customer.data.id;

      updateStore('customerId', customerId);

      addSessionToStore(response.data);

      return response;
    });
  });
};
export const getSessions = (options) => {
  return get(makeGetChatSessionsEndpoint(options)).then((response) => {
    const sessions = Array.isArray(response?.data) ? response.data : [];
    const withPubNub = sessions.filter((session) => {
      const pubnubAttribute = session?.attributes?.pubnub;
      return pubnubAttribute && !pubnubAttribute?.error;
    });

    withPubNub.forEach((session) => {
      addSessionToStore(session);
    });

    return { ...response, data: withPubNub };
  });
};
export const getSession = (sessionId: string) => {
  const validateSessionParamsError = validateSessionParams(sessionId);

  if (validateSessionParamsError) {
    return Promise.reject(validateSessionParamsError);
  }

  return get(makeChatSessionEndpoint(sessionId)).then((response) => {
    addSessionToStore(response.data);
    return response;
  });
};

export const updateSession = (
  sessionId: string,
  options?: UpdateSessionOptions,
) => {
  const validateSessionParamsError = validateSessionParams(sessionId);

  if (validateSessionParamsError) {
    return Promise.reject(validateSessionParamsError);
  }

  return put(makeChatSessionEndpoint(sessionId), {
    body: JSON.stringify(options),
  }).then((response) => {
    addSessionToStore(response.data);
    return response;
  });
};

export const updateSessionMessages = (parameters) => {
  const body = parameters?.body;
  return patch(makeChatSessionMessagesEndpoint(parameters), {
    body: JSON.stringify(body),
  });
};

export const markSessionAsRead = (sessionId: string) => {
  const validateSessionParamsError = validateSessionParams(sessionId);

  if (validateSessionParamsError) {
    return Promise.reject(validateSessionParamsError);
  }

  return patch(makeChatSessionReadEndpoint(sessionId));
};
